import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { SlideShowContext } from '@/components/SlideShow/context';
import { MainButton } from '@/components/ui/Button/Button';
import { toggleOpenPresentation } from '@/redux/reducers/modalsReducer';
import { useAppDispatch } from '@/redux/store';

import css from './styles.module.scss';

interface PresentationSlideProps {
  image: {
    alt: string;
    png: string;
  };
  btnText: string;
}

const PresentationSlide: FC<PresentationSlideProps> = ({ image, btnText }) => {
  const { setActiveSlide, activeSlide, slidesQuantity } =
    useContext(SlideShowContext);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const toNextSlide = (): void => {
    if (activeSlide === slidesQuantity - 1) {
      dispatch(toggleOpenPresentation());
    } else {
      setActiveSlide((state) => state + 1);
    }
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex flex-col justify-end pb-10 z-[999]">
      <img
        className="w-full absolute left-0 top-1/2 -translate-y-1/2"
        src={image.png}
        alt={image.alt}
      />
      <div className="px-10 relative z-[1]">
        <MainButton onClick={toNextSlide} text={t(btnText)} />
      </div>
      <div className={css.elipseGradient}></div>
    </div>
  );
};

export { PresentationSlide };
